import { render, staticRenderFns } from "./DeleteOutline.vue?vue&type=template&id=2668dfba"
import script from "./DeleteOutline.vue?vue&type=script&lang=js"
export * from "./DeleteOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports